import { forwardRef } from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react-lite';

export type PageProps = {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
};

const PageComponent = forwardRef<HTMLDivElement, PageProps>(
  ({ children, className, style }, ref) => {
    return (
      <div
        ref={ref}
        className={cx(
          'page flex-column m-2 md:m-4 md:mb-0 flex-1 min-h-0',
          className
        )}
        style={style}
      >
        {children}
      </div>
    );
  }
);

PageComponent.displayName = 'Page';

export const Page = observer(PageComponent);
